<template>
  <div class="bookNow">
    <form method="get" :action="actionUrl">
      <div class="row">
        <div class="col-xs-12 col-sm-6 mt-1">
            <datepicker v-model="dateBook"
               :lower-limit="today"
               class="form-control custom-select-sm"
            />
        </div>
        <div class="col-xs-12 col-sm-6 mt-1">
          <select v-model="paxs" class="form-control custom-select custom-select-sm" aria-label="Default select example">
            <option selected value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
          </select>
        </div>
      </div>
      <hr>

      <!-- Transporte -->
      <div v-if="paxs" class="row">
        <div class="col-12">
          <select required v-model="bookTransport" class="custom-select custom-select-sm">
            <option selected value="">{{ t('select') }}</option>
            <option value=0>{{ t('no') }}</option>
            <option value=1>{{ t('yes') }}</option>
          </select>
        </div>

        <div v-if="bookTransport == 1" class="col-12 mt-2">
          <select v-if="!msgNotTransport" v-model="selectedTransport" class="custom-select custom-select-sm">
            <option v-for="(t, index) in transAvailable" :key="index" :value="t">{{ t.label }}</option>
          </select>
          <div v-if="selectedTransport && selectedTransport.description" class="text-caption trans-description">
            {{ selectedTransport.description }}
          </div>
          <div v-if="msgNotTransport" class="text-caption text-danger">
            {{ t('noAvailableTransfer') }}
          </div>
        </div>

      </div>

      <div class="row mt-2 pa-1">
        <div class="col-6"><b>{{ t('totalPagar') }}</b></div>
        <div class="col-6 text-right"><small>{{ currency }}</small> {{ totalPrice }}</div>
        <div v-if="loading" class="col-12 text-left text-caption">{{ t('loading') }}</div>
      </div>

      <hr>
      <div class="row mt-4">
        <div v-if="paxs" class="col-12">
          <!-- <input name="csrfmiddlewaretoken" type="hidden" :value="csrftoken"> -->
          <input name="tour" type="hidden" :value="idtour">
          <input name="date" type="hidden" :value="dateBookFormat">
          <input name="paxs" type="hidden" :value="paxs">
          <input name="trans" type="hidden" :value="selectedTransport.id">
          <button :disabled="!selectedTransport || loading" class="btn btn btn-dark btn-block">{{ t('book') }}</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { ref, watch, computed, onMounted, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import Datepicker from 'vue3-datepicker'

import api from '../api/api'


export default ({
  name: 'BookNow',
  props: {
    idtour: {
      type: String,
      required: true
    }
  },

  setup(props) {
    const currency = ref('')
    const dateBook = ref(new Date())
    const today = ref(new Date())
    const paxs = ref(2)
    const total = ref(0)
    const loading = ref(false)
    const bookTransport = ref('')
    const transAvailable = ref([])
    const selectedTransport = ref([])
    const msgNotTransport = ref(false)

    const { t, locale } = useI18n({
      inheritLocale: true,
      useScope: 'local'
    })

    onMounted(() => {
      nextTick(async function() {
        loading.value = true
        // Calculamos el precio
        const data = {
          idTour: props.idtour,
          paxs: paxs.value
        }
        calcularPrecio(data)
      })
    })

    watch(
      () => paxs.value,
      async(val) => {
        const data = {
          idTour: props.idtour,
          paxs: val
        }
        calcularPrecio(data)
      }
    ),

    watch(
      () => bookTransport.value,
      async () => {
        // No hay transporte seleccionado
        if (bookTransport.value == 0){
          selectedTransport.value =  {
            id: null,
            label: '',
            price: 0,
            description: ''
          }
          return
        }
        loading.value = true
        let response = ''
        try {
          response = await api.getTransTour(props.idtour)
        }catch (e) {
          console.log(`Error at calculate price: ${e}`)
        } finally {
          loading.value = false
        }

        // If not exist transport, then show message no available transports and return
        if (!response.data.length) {
          msgNotTransport.value = true
          return
        }
        // Filtrar los transportes segun la cantidad de paxs seleccionados
        const trans = response.data.filter(
          item => (item.desde <= paxs.value) && (item.hasta >= paxs.value)
        )

        transAvailable.value = trans.map(element => {
          return { 
            id: element.id, 
            label: `${element.nombre_tipo_transporte}(${element.precio})`,
            price: element.precio,
            description: element.descripcion
          }
        })

        selectedTransport.value = transAvailable.value[0]
      }
    )

    const totalPrice = computed(() => {
      return selectedTransport.value.price 
        ? (total.value + Number(selectedTransport.value.price)).toFixed(2)
        : total.value.toFixed(2)
    })

    const dateBookFormat = computed (() => {
      return `${dateBook.value.getFullYear()}-${dateBook.value.getMonth()+1}-${dateBook.value.getDate()}`
    })

    const actionUrl = computed(() => {
      return locale.value !== 'en' ? `/${locale.value}/book/` : '/book/'
    })

    async function calcularPrecio (data) {
      loading.value = true
      bookTransport.value = ''
      try {
        const response = await api.checkPriceTour(data)
        total.value = Number(response.data.tatal_pay)
        currency.value = response.data.currency
      } catch (error) {
        console.log(error)
      } finally {
        loading.value = false
      }
    }

    return { 
      paxs, 
      total, 
      today, 
      loading,
      currency,
      dateBook,
      dateBookFormat,
      totalPrice, 
      bookTransport,
      transAvailable,
      selectedTransport,
      msgNotTransport,
      Datepicker, t, actionUrl
    }
  }
})
</script>

<style scoped>
.text-caption {
  font-size: 0.75rem
}
.trans-description {
  color: rgb(218, 129, 28);
  padding: 2px 2px 2px 2px;
  margin: 5px 0px 0px 0px;
  border: dotted 1px rgb(161, 157, 157);
  background-color: #eee;
  border-radius: 3px;
}
</style>